import React from 'react';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { palette } from '../../../../../../theme/default';

const RateCell = ({ value, row }) => {
  if (row?.original?.isTotalRow) {
    return (
      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: 700,
          color: palette.text.secondary,
          width: '100%',
        }}
      >
        Total($)
      </Typography>
    );
  }
  return (
    <Typography
      sx={{
        fontSize: '16px',
        fontWeight: 500,
        width: '100%',
      }}
    >
      {value}
    </Typography>
  );
};

RateCell.propTypes = {
  value: PropTypes.string,
  row: PropTypes.shape({
    original: PropTypes.shape({
      quantityTotal: PropTypes.string,
      isTotalRow: PropTypes.bool,
    }),
  }).isRequired,
};

RateCell.defaultProps = {
  value: '',
};

export default RateCell;
